import axios from "@/plugins/axios";
import { applyKotTheme } from "@/utils/kotTheme";
import { applyPwaSetting } from "@/utils/pwa";

export const state = () => ({
  // Must be an object so pages can read `setting.kitchen_id`, `setting.guest`, etc.
  setting: null,
});

export const mutations = {
  addSetting(state, data) {
    state.setting = data;
    applyKotTheme(data && data.theme_primary_color);
    applyPwaSetting(!!(data && data.pwa_enabled)).catch(() => {});
  },
};

export const actions = {
  GetSettings({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`hms/kot-configuration/1`)
        .then((res) => {
          commit("addSetting", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
  
  export const getters = {

  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  // this.$store.commit('orders/addOrders',roomData)
  // this.$store.commit('orders/removeorder',index)
  
  // computed:{
  //      ...mapState(orders,['orders'])
  // },
  // methods:{
  //   removeOrder(index){
  //     this.$store.commit('orders/removeorder',index)
  
  //   }
  // }
  
  // <div v-for="(item,index) in orders">
  //      <button @click="removeOrder(index)">Remove</button>
  //</div >
  